import {
  ContactabilityStatus,
  MemberContactabilityStatus,
} from '@tribeplatform/gql-client/types'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Text } from '@tribeplatform/react-ui-kit/Text'

import { T } from '../../i18n/index.js'
import { useChatActions } from '../hooks/useChatActions.js'

interface Props {
  chatId: string
  contactability: MemberContactabilityStatus
}

export const NotContactable = ({ chatId, contactability }: Props) => {
  const { unblockMember, isUnblocking } = useChatActions({ chatId })
  const { status, memberId } = contactability
  const showGenericMessage =
    status === ContactabilityStatus.Unknown ||
    status === ContactabilityStatus.LimitedBySitePrivacy ||
    status === ContactabilityStatus.LimitedByContactPrivacy

  return (
    <div className="px-2 pb-4">
      <div className="border border-line-subdued rounded-lg shadow-base">
        <div className="flex items-center justify-center text-center text-content-muted gap-2 p-4">
          <p className="text-sm">
            {status === ContactabilityStatus.BlockedByYou && (
              <div className="flex flex-col gap-2 items-center">
                <Text>
                  <T
                    defaultMessage="You have blocked this member. Unblock them to message them."
                    id="Messaging.Chat.Inactive.Message.BlockedByYou"
                  />
                </Text>
                <Button
                  variant="secondary"
                  onClick={() => unblockMember(memberId)}
                  loading={isUnblocking}
                  disabled={isUnblocking}
                >
                  <T
                    defaultMessage="Unblock"
                    id="Messaging.Chat.Inactive.Message.Unblock"
                  />
                </Button>
              </div>
            )}

            {status === ContactabilityStatus.BlockedYou && (
              <T
                defaultMessage="This member has blocked you, you cannot message them."
                id="Messaging.Chat.Inactive.Message.BlockedYou"
              />
            )}
            {showGenericMessage && (
              <T
                defaultMessage="Unable to message this member."
                id="Messaging.Chat.Inactive.Message.Unknown"
              />
            )}
          </p>
        </div>
      </div>
    </div>
  )
}
